import Http from "../../service/api";
import { judgeIsSplice } from "../../common/utils";

// -----------------------------  用户信息  -------------------------
/**
 * 获取登陆用户的信息 get query
 * @param {*} params 
 */
export async function getLoginUserInfo(params: any) {
  return Http.get('/human_info/v1/emp/info', params);
}
// -----------------------------  首页  -------------------------
/**
 * 首页获取类型及课程集合 get query
 * @param {*} params 
 */
export async function getTypelist(params: any) {
  return Http.get(`/v1/index/typelist${judgeIsSplice()}`, params);
}
/**
 * 查询轮播图集合 get query
 * @param {*} params 
 */
export async function getBannerList(params: any) {
  return Http.get(`/v1/slideshow/list${judgeIsSplice()}`, params);
}
// -----------------------------  我的课程  -------------------------
/**
 * 首页查询课程集合 get query
 * @param {*} params 
 */
export async function getCourseList(params: any) {
  return Http.get(`/v1/index/curriculumlist${judgeIsSplice()}`, params);
}
/**
 * 首页查询课程集合 get query
 * @param {*} params 
 */
export async function getTestList(params: any) {
  return Http.get(`/api/v1/exam/listMyExam${judgeIsSplice()}`, params);
}
/**
 * 首页获取菜单下的类型和标签 get query
 * @param {*} params 
 */
export async function getAllTypes(params: any) {
  return Http.get(`/v1/index/typetags${judgeIsSplice()}`, params);
}
// -----------------------------  课程详情-课程信息  -------------------------
/**
 * 新增课程点击记录 post formData
 * @param {*} params 
 */
export async function addCurriculum(params: any) {
  return Http.post(`/v1/count/addcurriculum${judgeIsSplice()}`, params, `formData`);
}
/**
 * 新增课件点击记录 post formData
 * @param {*} params 
 */
export async function addCoursewareCount(params: any) {
  return Http.post(`/v1/count/addcourseware${judgeIsSplice()}`, params, `formData`);
}
/**
 * 获取某个课程的信息 get query
 * @param {*} params 
 */
export async function getCourseInfo(params: any) {
  return Http.get(`/v1/curriculum/info${judgeIsSplice()}`, params);
}
/**
 * 查询推荐课程集合 get query
 * @param {*} params 
 */
export async function getRecommendList(params: any) {
  return Http.get(`/v1/curriculum/recommendlist${judgeIsSplice()}`, params);
}
/**
 * 查询课件集合（用户） get query
 * @param {*} params 
 */
export async function getCoursewareList(params: any) {
  return Http.get(`/v1/courseware/ulist${judgeIsSplice()}`, params);
}
/**
 * 获取课件信息 get query
 * @param {*} params 
 */
export async function getCourseWareInfo(params: any) {
  return Http.get(`/v1/courseware/info${judgeIsSplice()}`, params);
}
/**
 * 获取课程进度信息 get query
 * @param {*} params 
 */
export async function getCourseProcess(params: any) {
  return Http.get(`/v1/progress/curriculum${judgeIsSplice()}`, params);
}
/**
 * 新增用户的观看记录 post formData
 * @param {*} params 
 */
export async function addViewRecord(params: any) {
  return Http.post(`/v1/viewrecord/add${judgeIsSplice()}`, params, `formData`);
}
// 评论
/**
 * 新增评论 post formData
 * @param {*} params 
 */
export async function addComment(params: any) {
  return Http.post(`/v1/comment/add${judgeIsSplice()}`, params, `formData`);
}
/**
 * 删除评论 delete formData
 * @param {*} params 
 */
export async function delComment(params: any) {
  return Http.deletes(`/v1/comment/del${judgeIsSplice()}`, params);
}
/**
 * 获取评论集合 get query
 * @param {*} params 
 */
export async function getCommentList(params: any) {
  return Http.get(`/v1/comment/list${judgeIsSplice()}`, params);
}
/**
 * 新增回复评论 post formData
 * @param {*} params 
 */
export async function addReplyComment(params: any) {
  return Http.post(`/v1/comment/reply${judgeIsSplice()}`, params, `formData`);
}
/**
 * 获取回复评论集合 get query
 * @param {*} params 
 */
export async function getReplyCommentList(params: any) {
  return Http.get(`/v1/comment/replylist${judgeIsSplice()}`, params);
}
// 收藏
/**
 * 新增收藏 post formData
 * @param {*} params 
 */
export async function addCollection(params: any) {
  return Http.post(`/v1/collection/add${judgeIsSplice()}`, params, `formData`);
}
/**
 * 取消收藏 delete formData
 * @param {*} params 
 */
export async function delCollection(params: any) {
  return Http.deletes(`/v1/collection/del${judgeIsSplice()}`, params);
}
// 评分
/**
 * 新增或更新评分 post formData
 * @param {*} params 
 */
export async function addScour(params: any) {
  return Http.post(`/v1/score/addup${judgeIsSplice()}`, params, `formData`);
}
// 视频更新
/**
 * 更新课件学习进度 post formData
 * @param {*} params 
 */
export async function updateProgress(params: any) {
  return Http.post(`/v1/progress/update${judgeIsSplice()}`, params, `formData`);
}
// ====================== 个人模块 ======================
// 我的收藏
/**
 * 获取收藏的课程 get query
 * @param {*} params 
 */
export async function getCollectList(params: any) {
  return Http.get(`/v1/collection/list${judgeIsSplice()}`, params);
}
// 获取学习
/**
 * 获取最近学习的课程集合 get query
 * @param {*} params 
 */
export async function getCurriculumLatest(params: any) {
  return Http.get(`/v1/curriculum/latest${judgeIsSplice()}`, params);
}
// ====================== 考试相关 ======================
/**
 * 获取当前课件的考试设置信息 get query
 * @param {*} params 
 */
export async function getExamInfo(params: any) {
  return Http.get(`/v1/exam/info${judgeIsSplice()}`, params);
}
/**
 * 完成考试，获取考试信息 get query
 * @param {*} params 
 */
export async function getExamResult(params: any) {
  return Http.get(`/v1/exam/get${judgeIsSplice()}`, params);
}
/**
 * 考试星回调接口 post json
 * @param {*} params 
 */
export async function getExamCallback(params: any) {
  return Http.post(`/v1/exam/callback/100942${judgeIsSplice()}`, params);
}
